/**
 * @file Homepage Slider
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import KeenSlider from 'keen-slider';

/**
 * Homepage Slider component
 */
const vHpSlider = () => {
	const hpSlider = document.querySelector( '.v-hp-slider' );

	if ( ! hpSlider ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const backdrop = hpSlider.querySelector( '.v-hp-slider__inner' );
	const captions = document.querySelectorAll( '.v-navigation__caption' );
	const query    = window.matchMedia( '(max-width: 414px)' );
	/* eslint-disable no-unused-vars */
	let interval;

	new KeenSlider( '.v-hp-slider__keen', {
		loop:     true,
		controls: false,
		mounted:  () => {
			ScrollTrigger.refresh();
		},
		created: ( instance ) => {
			if ( backdrop.classList.contains( 'v-hp-slider__inner--loading' ) ) {
				setTimeout( () => {
					backdrop.classList.remove( 'v-hp-slider__inner--loading' );
				}, 750 );
			}

			interval = setInterval( () => {
				backdrop.classList.add( 'v-hp-slider__inner--loading' );
				if ( ! query.matches ) {
					const angles   = hpSlider.querySelectorAll( '.v-hp-slider__frame' );

					setTimeout( () => {
						[ ...angles ].forEach( ( f ) => {
							f.dataset.visible = f.dataset.visible === 'true' ? 'false' : 'true';
						} );
					}, 750 );
				}

				setTimeout( () => {
					instance.next();
				}, 1500 );
			}, 8000 );
		},
		slideChanged: () => {
			setTimeout( () => {
				if ( backdrop.classList.contains( 'v-hp-slider__inner--loading' ) ) {
					backdrop.classList.remove( 'v-hp-slider__inner--loading' );
				}
			}, 500 );
		},
		move: ( instance ) => {
			if ( ! captions ) {
				return;
			}

			const opacities = instance.details().positions.map( ( slide ) => slide.portion );
			captions.forEach( ( element, idx ) => {
				element.style.opacity = opacities[ idx ];
			} );
		},
	} );
};

export default vHpSlider;
